<template>
<layout-content>
  <template #toolbar>
    <el-date-picker
      v-model="query.dateTime"
      size="small"
      type="month"
      value-format="yyyy/MM"
      :clearable="false"
      style="width: 150px;"
    >
    </el-date-picker>

    <el-radio-group v-model="query.isSiteMerge" size="small" @change="getData">
      <el-radio-button :label="true">聚合数据</el-radio-button>
      <el-radio-button :label="false">站点数据</el-radio-button>
    </el-radio-group>

    <completed-query v-model="query.isAuditCompleted" :is-show-fuse="false" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <sidebar-content sidebarWidth="180px" title="站点选择">
      <template #silder-header-toolbar>
        <select-ctrl-group
          :ids="query.siteIds"
          :options="filterSites"
          show-icon
          style="padding-bottom:0;"
          @change="onSelectCtrlChange"
        />
      </template>

      <template #sidebar-body>
        <div class="device-dropdown-selector-wrapper">
          <div class="device-dropdown-selector-wrapper-inner">
            <el-tree
              ref="site-tree"
              :data="filterSites"
              :props="{
                value: 'id',
                label: 'name'
              }"
              node-key="id"
              show-checkbox
              accordion
              check-on-click-node
              :default-checked-keys="query.siteIds"
              @check="onSiteCheckChange"
            />
            <!-- <div
              v-for="site in filterSites"
              :key="site.id"
              class="device-dropdown-selector"
            >
              <el-checkbox v-model="query.siteIds" :label="site.id" @change="getData">{{site.name}}</el-checkbox>
            </div> -->
          </div>
        </div>
      </template>

      <template #sidebar-content-body>
        <div style="width: 100%;height: 100%;display: flex;align-items:flex-start;" v-if="query.isSiteMerge">
          <div style="flex: 1 0 33%;height: 450px;" v-for="(el, i) in dataList" :key="i">
            <monthly-chart
              ref="charts"
              :name="el.name"
              :data="el.data"
            />
          </div>
        </div>
        <section class="data-wrapper" v-if="!query.isSiteMerge">
          <section class="site-data">
            <div v-for="(el, index) in siteDataList" :key="index">
              <div class="site-data-header">
                <span>{{el.name}}</span>
              </div>
              <div class="site-data-body">
                <div style="width: 100%;height: 100%;display: flex;align-items:flex-start;">
                  <div style="flex: 1 0 33%;height: 100%;" v-for="(item, i) in el.dataList" :key="i">
                    <monthly-chart
                      ref="charts"
                      :name="item.name"
                      :data="item.data"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
      </template>
    </sidebar-content>
  </template>
</layout-content>
</template>

<script>
import BaseFactorData from '../../../BaseFactorData'
import LayoutContent from '../../../../components/Layout/Content'
import MonthlyChart from '../../../../components/Data/MonthlyChart'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

export default {
  name: 'StatisticalAnalysisAQIMonthly',
  routeInfo: {
    label: '月度统计'
  },
  extends: BaseFactorData,
  components: {LayoutContent, MonthlyChart},
  data () {
    return {
      query: {
        dateTime: new Date().format('YYYY/MM'),
        factorIds: [1001, 1003, 1005, 1006, 1007, 1008],
        isAuditCompleted: false, // finished
        isSiteMerge: true
      },
      flag: {
        merge: true,
        site: false
      },
      activeName: 'merge',
      chartDatas: [],
      dataList: [],
      siteDataList: []
    }
  },
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false)
      ]
    },
    minSiteSelectNumber: () => 1,
    completeAllData: () => false,
    valueProp: () => 'value',
    _siteDeviceCategoryConfig () {
      let bit = 0
      return this.siteDeviceCategoryConfig.reduce((map, deviceCategoryConfig) => {
        let {categoryId} = deviceCategoryConfig
        let num = 1 << bit

        if (!map.map[categoryId]) {
          map.map[categoryId] = {
            bit: bit,
            filter: deviceCategoryConfig.filter
          }
          map.total |= num
          map.min |= num & (-deviceCategoryConfig.required)
          bit++
        }

        return map
      }, {
        map: {},
        total: 0,
        min: 0
      })
    },
    _filterSites () {
      let {profileSiteDevices} = this

      if (profileSiteDevices.length === 0) {
        return []
      }

      let {_siteDeviceCategoryConfig: {map: deviceCategoryMap, total, min}, profileSiteMap} = this

      return Object.values(profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let site = profileSiteMap[siteId]

        if (!site) {
          return map
        }

        let deviceCategoryConfig = deviceCategoryMap[siteDevice.categoryId]

        if (deviceCategoryConfig) {
          let {filter} = deviceCategoryConfig
          let siteDeviceFactors = filter instanceof Function
            ? filter(siteDevice.siteDeviceFactors)
            : [...siteDevice.siteDeviceFactors]

          if (siteDeviceFactors.length > 0) {
            let {bit} = deviceCategoryConfig
            let tmpSite = map[siteId]

            if (!tmpSite) {
              tmpSite = map[siteId] = {
                id: siteId,
                name: site.name,
                total: 0,
                devices: []
              }
            }

            tmpSite.total |= 1 << bit
            tmpSite.devices.push({
              ...siteDevice,
              siteDeviceFactors
            })
          }
        }

        return map
      }, {})).filter(site => (site.total & total) >= min)
    },
    filterSites () {
      return this._filterSites
    },
    filterSiteMap () {
      return this.filterSites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})
    },
    isNoSelectedSites () {
      return this.query.siteIds.length === 0
    },
    canNotSearch () {
      return this.isNoSelectedSites
    }
  },
  methods: {
    onAuditCompletedChanged () {
      this.afterSetSiteIds()
    },
    handleClick (tab, event) {
      let {flag} = this
      this.query.isSiteMerge = flag[tab.name]
      this.getData()
    },
    renderData () {
      setTimeout(() => {
        let dataRenders = this.getDataRenders()

        if (dataRenders) {
          dataRenders.forEach(dataRender => dataRender.render())
        }
      }, 0)
    },
    getDataRenders () {
      return this.$refs['charts']
    },
    getData () {
      this.changeLoadStatus(true)
      this.dataTableKey = 0
      let {query} = this
      if (query.siteIds.length === 0) {
        this.siteDataList = []
        this.dataList = []
        this.changeLoadStatus(false)
        return false
      }
      this.$api.Aqi.getMonthly(query).then(backData => {
        if (query.isSiteMerge) {
          this.siteDataList = []
        } else {
          this.dataList = []
        }
        this.formatData(backData)
        this.renderData()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    formatData (data) {
      if (data.length === 0) {
        this.siteDataList = []
        this.dataList = []
        return false
      }
      let {query: {isSiteMerge, siteIds}, factorMap, filterSiteMap} = this
      // grade状态码
      let level = {
        1: '优',
        2: '良',
        3: '轻度污染',
        4: '中度污染',
        5: '重度污染',
        6: '严重污染'
      }
      if (isSiteMerge) {
        let compositePieChartData = data.compositeIndex.map(el => {
          return {
            name: factorMap[el.factorId].name,
            value: Number.isFinite(el.value) ? el.value.toFixed(3) : el.value
          }
        })
        let gradePieChartData = data.grade.map(el => {
          return {
            name: level[el.grade],
            value: el.count ? el.count : '--'
          }
        })
        let primaryPollutantPieChartData = data.primaryPollutant.map(el => {
          return {
            name: el.factorName,
            value: el.count ? el.count : '--'
          }
        })

        let temp = [{
          name: '空气质量',
          data: gradePieChartData
        }, {
          name: '首要污染物',
          data: primaryPollutantPieChartData
        }, {
          name: '综合指数',
          data: compositePieChartData
        }]
        this.dataList = temp
      } else {
        let siteData = siteIds.reduce((map, el) => {
          map[el] = {
            name: filterSiteMap[el].name,
            compositePieChartData: [],
            gradePieChartData: [],
            primaryPollutantPieChartData: []
          }

          return map
        }, {})

        data.compositeIndex.forEach(el => {
          let site = siteData[el.siteId]
          site.compositePieChartData.push({
            name: factorMap[el.factorId].name,
            value: Number.isFinite(el.value) ? el.value.toFixed(3) : el.value
          })
        })

        data.grade.forEach(el => {
          let site = siteData[el.siteId]
          site.gradePieChartData.push({
            name: level[el.grade],
            value: el.count ? el.count : '--'
          })
        })

        data.primaryPollutant.forEach(el => {
          let site = siteData[el.siteId]
          site.primaryPollutantPieChartData.push({
            name: el.factorName,
            value: el.count ? el.count : '--'
          })
        })

        let siteDataList = Object.values(siteData).map(el => {
          let temp = {
            name: el.name,
            dataList: []
          }
          temp.dataList.push({name: '空气质量', data: el.gradePieChartData})
          temp.dataList.push({name: '首要污染物', data: el.primaryPollutantPieChartData})
          temp.dataList.push({name: '综合指数', data: el.compositePieChartData})

          return temp
        })

        this.siteDataList = Object.values(siteDataList)
      }
    },
    onSiteCheckChange () {
      let checkedSiteList = this.getSiteTree().getCheckedNodes()
      this.query.siteIds = checkedSiteList.filter(item => !Array.isArray(item.children)).map(item => item.id)
      this.getData()
    },
    setCheckedKeys (siteIds) {
      let factorTree = this.getSiteTree()

      if (factorTree) {
        factorTree.setCheckedKeys(siteIds)
        this.getData()
      }
    },
    getSiteTree () {
      return this.$refs['site-tree']
    },
    onSelectCtrlChange (ids) {
      this.setCheckedKeys(ids)
    }
  },
  created () {
    delete this.query.beginTime
    delete this.query.endTime
    delete this.query.dataType
  }
}
</script>

<style lang="scss" scoped>
.data-wrapper {
  .site-data {
    & + .site-data {
      margin-top: 20px;
    }
  }

  .site-data-header {
    line-height: 1.8em;
    padding: 0 10px;
    background: -webkit-gradient(linear, left top, right top, from(#fbc15a), to(#fff));
    background: linear-gradient(to right, #fbc15a 0%, #fff 100%);
    color: #ffffff;
    font-weight: 600;
  }

  .site-data-body {
    height: 400px;
  }
}
.device-dropdown-selector-wrapper {
  display: grid;
  grid-template-rows: 100%;
  height: 400px;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .device-dropdown-selector-wrapper-inner {
    padding: 12px 0 ;
    overflow: auto;
  }

  .device-dropdown-selector {
    line-height: 1.7;
    -webkit-font-smoothing: antialiased;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/04AQI/04Monthly-Statistics/index.vue